import { PipeTransform, Pipe } from '@angular/core';
import * as d3 from 'd3';
import { RoutingService } from '../service/routing.service';

/**
 * This pipe defines the color of items sorted by volume ratio
 */
@Pipe({ name: 'colorRatio' })
export class ColorRatioPipe implements PipeTransform {
  constructor(public routing: RoutingService) {}
  transform(
    value: number | null | undefined,
    min: number,
    max: number,
  ): string {
    if (value || value === 0) {
      if (min > 1) {
        min = 1;
      }
      if (max < 1) {
        max = 1;
      }
      const colors = [
        min !== 1 ? '#f26e6e' : '#f2f2f2',
        '#f2f2f2',
        max !== 1 ? '#60e9d0' : '#f2f2f2',
      ];
      const colorScale = d3
        .scaleLinear<string>()
        .domain([min, 1, max])
        .range(colors);
      return colorScale(Number(value.toFixed(2))).toString();
    } else {
      // no-data rows: neutral that reads on the active theme's surface
      return this.routing.theme === 'light'
        ? 'rgb(216,216,216)'
        : 'rgb(120,120,120)';
    }
  }
}
